import { writable, derived } from 'svelte/store';
import { GamePhases } from '../types';
export const phases = writable({ player: GamePhases.SetMoves, opponent: GamePhases.SetMoves });
export const phase = derived(phases, $phases => $phases.opponent === GamePhases.SelectMove && $phases.player === GamePhases.SelectMove ?
    GamePhases.SelectMove :
    GamePhases.SetMoves);
